module.exports = __webpack_public_path__ + "static/media/Lafayette Cam 12.d18a590e.webp";